export function notificationTargetsActiveSession(activeSessionID?: string, notificationSessionID?: string) {
  return !!activeSessionID && !!notificationSessionID && activeSessionID === notificationSessionID
}

export function acknowledgeVisibleSession(input: {
  routeMatches: boolean
  visibilityState: DocumentVisibilityState
  focused: boolean
  sessionID: string | undefined
  at: number
  markViewed: (sessionID: string, at: number) => void
}) {
  const viewed = input.routeMatches && input.visibilityState === "visible" && input.focused
  if (viewed && input.sessionID) input.markViewed(input.sessionID, input.at)
  return viewed
}

type NotificationRoute = {
  machine?: string
  session?: string
}

function notificationRoute(value: string) {
  let parts: string[]
  try {
    parts = new URL(value, "https://mux.local").pathname.split("/").filter(Boolean).map(decodeURIComponent)
  } catch {
    return undefined
  }
  const machineIndex = parts.indexOf("m")
  const sessionIndex = parts.indexOf("session")
  return {
    machine: machineIndex >= 0 ? parts[machineIndex + 1] : undefined,
    session: sessionIndex >= 0 ? parts[sessionIndex + 1] : undefined,
  } satisfies NotificationRoute
}

export function notificationTargetsCurrentSession(currentURL: string, notificationHref: string) {
  const current = notificationRoute(currentURL)
  const target = notificationRoute(notificationHref)
  if (!current?.session || !target?.session || current.session !== target.session) return false
  if (!target.machine) return true
  return current.machine === target.machine
}

export function suppressSystemNotification(
  visibilityState: DocumentVisibilityState,
  focused: boolean,
  currentURL?: string,
  notificationHref?: string,
) {
  if (visibilityState !== "visible" || !focused) return false
  if (currentURL === undefined || notificationHref === undefined) return true
  return notificationTargetsCurrentSession(currentURL, notificationHref)
}
